// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen.js';
/**
 * Check if the service is alive and responding
 */
export const getHealth = (options) => (options?.client ?? client).get({ url: '/api/v1/monitoring/health', ...options });
/**
 * Check if the service is ready to accept traffic
 */
export const getHealthReady = (options) => (options?.client ?? client).get({ url: '/api/v1/monitoring/health/ready', ...options });
/**
 * Create document and get presigned upload URL
 */
export const createDocument = (options) => (options.client ?? client).post({
    url: '/api/v1/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a document
 *
 * Deletes document from storage and database
 */
export const deleteDocument = (options) => (options.client ?? client).delete({ url: '/api/v1/documents/{id}', ...options });
/**
 * Get document detail by id
 */
export const getDocument = (options) => (options.client ?? client).get({ url: '/api/v1/documents/{id}', ...options });
/**
 * Verify uploaded document
 */
export const verifyDocument = (options) => (options.client ?? client).patch({ url: '/api/v1/documents/{id}', ...options });
/**
 * Generate short-lived download URL
 */
export const getDocumentDownloadUrl = (options) => (options.client ?? client).post({ url: '/api/v1/documents/{id}/download', ...options });
/**
 * Create presigned URL for image upload
 *
 * @deprecated
 */
export const createImageUpload = (options) => (options.client ?? client).post({
    url: '/api/v1/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Validate uploaded image and get public URL
 *
 * @deprecated
 */
export const completeImageUpload = (options) => (options.client ?? client).patch({ url: '/api/v1/images/{key}', ...options });
/**
 * Get onboarding status and current progress data
 *
 * @deprecated
 */
export const getOnboardingStatus = (options) => (options?.client ?? client).get({ url: '/api/v1/onboarding', ...options });
/**
 * Set user role (founder or investor)
 *
 * @deprecated
 */
export const setOnboardingRole = (options) => (options.client ?? client).patch({
    url: '/api/v1/onboarding/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Mark onboarding as completed
 *
 * Validates all required fields and marks onboarding as complete. Sets startup status to active if founder. Optionally saves attribution data.
 *
 * @deprecated
 */
export const completeOnboarding = (options) => (options?.client ?? client).patch({
    url: '/api/v1/onboarding/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * Get current user's profile data
 *
 * @deprecated
 */
export const getMe = (options) => (options?.client ?? client).get({ url: '/api/v1/users/me', ...options });
/**
 * Update current user's profile data
 *
 * Update user information including name, bio, location, and social links
 *
 * @deprecated
 */
export const updateMe = (options) => (options?.client ?? client).patch({
    url: '/api/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * Get user by ID
 *
 * Get any user profile by ID
 *
 * @deprecated
 */
export const getUserById = (options) => (options.client ?? client).get({ url: '/api/v1/users/{id}', ...options });
/**
 * Store raw LinkedIn profile data for a user
 *
 * Service-only endpoint for storing raw LinkedIn scrape data.
 *
 * @deprecated
 */
export const updateUserLinkedInData = (options) => (options.client ?? client).patch({
    url: '/api/v1/users/{id}/linkedin-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove founder's resume
 *
 * Unlink the resume from founder profile. Document remains in storage.
 *
 * @deprecated
 */
export const unlinkFounderResume = (options) => (options?.client ?? client).delete({ url: '/api/v1/users/me/resume', ...options });
/**
 * Link founder's resume
 *
 * Link an uploaded document as the founder resume.
 *
 * @deprecated
 */
export const linkFounderResume = (options) => (options.client ?? client).post({
    url: '/api/v1/users/me/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Accept terms and conditions
 *
 * Record user acceptance of the current terms and conditions version.
 *
 * @deprecated
 */
export const acceptTerms = (options) => (options.client ?? client).post({
    url: '/api/v1/users/me/accept-terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get user's startup
 *
 * Get the startup associated with the current founder user
 *
 * @deprecated
 */
export const getStartup = (options) => (options?.client ?? client).get({ url: '/api/v1/startups', ...options });
/**
 * Create startup during onboarding
 *
 * Create a new startup and associate it with the current founder. Creates startup in draft status.
 *
 * @deprecated
 */
export const createStartup = (options) => (options.client ?? client).post({
    url: '/api/v1/startups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Update startup details
 *
 * Update startup information. Allows partial updates during onboarding or in settings.
 *
 * @deprecated
 */
export const updateStartup = (options) => (options.client ?? client).patch({
    url: '/api/v1/startups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List startup documents
 *
 * Get all documents linked to a startup
 *
 * @deprecated
 */
export const listStartupDocuments = (options) => (options.client ?? client).get({ url: '/api/v1/startups/{startupId}/documents', ...options });
/**
 * Link document to startup
 *
 * Link a document to a startup with an optional label
 *
 * @deprecated
 */
export const linkStartupDocument = (options) => (options.client ?? client).post({
    url: '/api/v1/startups/{startupId}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Unlink document from startup
 *
 * Remove the link between a document and a startup (does not delete the document)
 *
 * @deprecated
 */
export const unlinkStartupDocument = (options) => (options.client ?? client).delete({ url: '/api/v1/startups/{startupId}/documents/{documentId}', ...options });
/**
 * Update document label
 *
 * Update the label of a document linked to a startup
 *
 * @deprecated
 */
export const updateStartupDocument = (options) => (options.client ?? client).patch({
    url: '/api/v1/startups/{startupId}/documents/{documentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List startup members
 *
 * Get all team members for a startup
 *
 * @deprecated
 */
export const listStartupMembers = (options) => (options.client ?? client).get({ url: '/api/v1/startups/{startupId}/members', ...options });
/**
 * Create startup member
 *
 * Add a new team member to a startup
 *
 * @deprecated
 */
export const createStartupMember = (options) => (options.client ?? client).post({
    url: '/api/v1/startups/{startupId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete startup member
 *
 * Remove a team member from a startup
 *
 * @deprecated
 */
export const deleteStartupMember = (options) => (options.client ?? client).delete({ url: '/api/v1/startups/{startupId}/members/{memberId}', ...options });
/**
 * Update startup member
 *
 * Update a team member of a startup
 *
 * @deprecated
 */
export const updateStartupMember = (options) => (options.client ?? client).patch({
    url: '/api/v1/startups/{startupId}/members/{memberId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get startup credit balance
 *
 * Get the current credit balance for a startup. Requires startup membership.
 *
 * @deprecated
 */
export const getStartupCreditBalance = (options) => (options.client ?? client).get({ url: '/api/v1/startups/{startupId}/credits/balance', ...options });
/**
 * List startup credit transactions
 *
 * List credit transactions for a startup. Requires startup membership.
 *
 * @deprecated
 */
export const listStartupCredits = (options) => (options.client ?? client).get({ url: '/api/v1/startups/{startupId}/credits', ...options });
/**
 * Get startup configuration data
 *
 * Returns categories, product stages, raise stages, and status options for dropdowns
 *
 * @deprecated
 */
export const getStartupConfig = (options) => (options?.client ?? client).get({ url: '/api/v1/configs/startup', ...options });
/**
 * Get investor configuration data
 *
 * Returns investment areas and regions for investor profile dropdowns
 *
 * @deprecated
 */
export const getInvestorConfig = (options) => (options?.client ?? client).get({ url: '/api/v1/configs/investor', ...options });
/**
 * Submit user feedback
 *
 * @deprecated
 */
export const createFeedback = (options) => (options.client ?? client).post({
    url: '/api/v1/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Email-only sign-in for data room access
 *
 * Create or find a user by email and establish a session without OTP verification
 *
 * @deprecated
 */
export const emailSignInForDataRoom = (options) => (options.client ?? client).post({
    url: '/api/v1/shares/auth/email-sign-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get data room content
 *
 * Get data room content by token (requires authentication)
 *
 * @deprecated
 */
export const getDataRoomContent = (options) => (options.client ?? client).get({ url: '/api/v1/shares/{token}', ...options });
/**
 * Record data room view
 *
 * Record that the current user viewed a data room
 *
 * @deprecated
 */
export const recordDataRoomView = (options) => (options.client ?? client).post({
    url: '/api/v1/shares/{token}/view',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get data room document download URL
 *
 * Generate a download URL for a startup document in a data room
 *
 * @deprecated
 */
export const getDataRoomDocumentDownload = (options) => (options.client ?? client).post({ url: '/api/v1/shares/{token}/documents/{documentId}/download', ...options });
/**
 * Get data room deck download URL
 *
 * Generate a download URL for the pitch deck in a data room
 *
 * @deprecated
 */
export const getPitchDeckDownload = (options) => (options.client ?? client).post({ url: '/api/v1/shares/{token}/pitch-deck/download', ...options });
/**
 * Get data room video URL
 *
 * Generate a presigned URL to stream the pitch recording video in a data room
 *
 * @deprecated
 */
export const getDataRoomVideoUrl = (options) => (options.client ?? client).post({ url: '/api/v1/shares/{token}/video-url', ...options });
/**
 * Connect with startup
 *
 * Send a connection request email to all startup members
 *
 * @deprecated
 */
export const connectWithStartup = (options) => (options.client ?? client).post({
    url: '/api/v1/shares/{token}/connect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Record data room heartbeats
 *
 * Record batched heartbeat events for engagement tracking
 *
 * @deprecated
 */
export const recordDataRoomHeartbeats = (options) => (options.client ?? client).post({
    url: '/api/v1/shares/{token}/heartbeats',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get data room analytics
 *
 * Get engagement analytics for a data room (startup owners only)
 *
 * @deprecated
 */
export const getDataRoomAnalytics = (options) => (options.client ?? client).get({ url: '/api/v1/shares/{token}/analytics', ...options });
/**
 * Revoke startup data room
 *
 * Revoke an active data room for a startup
 *
 * @deprecated
 */
export const revokeStartupDataRoom = (options) => (options.client ?? client).delete({ url: '/api/v1/shares/startup/{startupId}', ...options });
/**
 * Get startup data room
 *
 * Get the data room and view analytics for a startup
 *
 * @deprecated
 */
export const getStartupDataRoom = (options) => (options.client ?? client).get({ url: '/api/v1/shares/startup/{startupId}', ...options });
/**
 * Create startup data room
 *
 * Create a data room for a startup
 *
 * @deprecated
 */
export const createStartupDataRoom = (options) => (options.client ?? client).post({ url: '/api/v1/shares/startup/{startupId}', ...options });
/**
 * Get public investor profile by slug
 *
 * Returns publicly visible investor information and lead investor for the pitch page
 *
 * @deprecated
 */
export const getPublicInvestorBySlug = (options) => (options.client ?? client).get({ url: '/api/v1/public/investors/{slug}', ...options });
/**
 * Get user's investor
 *
 * Get the investor associated with the current investor user
 *
 * @deprecated
 */
export const getInvestor = (options) => (options?.client ?? client).get({ url: '/api/v1/investors', ...options });
/**
 * Create investor during onboarding
 *
 * Create a new investor and associate it with the current investor.
 *
 * @deprecated
 */
export const createInvestor = (options) => (options.client ?? client).post({
    url: '/api/v1/investors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor by ID
 *
 * Get any investor by ID
 *
 * @deprecated
 */
export const getInvestorById = (options) => (options.client ?? client).get({ url: '/api/v1/investors/{id}', ...options });
/**
 * Update investor details
 *
 * Update investor information including slug, investment focus, and other details.
 *
 * @deprecated
 */
export const updateInvestor = (options) => (options.client ?? client).patch({
    url: '/api/v1/investors/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor credit balance
 *
 * Get the current credit balance for an investor. Requires investor membership.
 *
 * @deprecated
 */
export const getInvestorCreditBalance = (options) => (options.client ?? client).get({ url: '/api/v1/investors/{id}/credits/balance', ...options });
/**
 * List investor credit transactions
 *
 * List credit transactions for an investor. Requires investor membership.
 *
 * @deprecated
 */
export const listInvestorCredits = (options) => (options.client ?? client).get({ url: '/api/v1/investors/{id}/credits', ...options });
/**
 * Get pitch detail
 *
 * Get detailed pitch session data including startup info, team members, raises, and documents. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const getInvestorPitchDetail = (options) => (options.client ?? client).get({ url: '/api/v1/investors/{id}/pitches/{pitchId}', ...options });
/**
 * Get document download URL
 *
 * Get a presigned download URL for a startup document. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const getInvestorPitchDocumentDownload = (options) => (options.client ?? client).post({ url: '/api/v1/investors/{id}/pitches/{pitchId}/documents/{documentId}/download', ...options });
/**
 * Get pitch deck download URL
 *
 * Get a presigned download URL for the pitch deck. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const getInvestorPitchDeckDownload = (options) => (options.client ?? client).post({ url: '/api/v1/investors/{id}/pitches/{pitchId}/pitch-deck/download', ...options });
/**
 * Get pitch video URL
 *
 * Get a presigned URL for the pitch recording video. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const getInvestorPitchVideoUrl = (options) => (options.client ?? client).post({ url: '/api/v1/investors/{id}/pitches/{pitchId}/video-url', ...options });
/**
 * Connect with startup
 *
 * Send a connection request to the startup team. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const investorConnectWithStartup = (options) => (options.client ?? client).post({
    url: '/api/v1/investors/{id}/pitches/{pitchId}/connect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Request personalized evaluation
 *
 * Deprecated. Use v2.requestInvestorEvaluation.
 *
 * @deprecated
 */
export const requestInvestorEvaluation = (options) => (options.client ?? client).post({ url: '/api/v1/investors/{id}/pitches/{pitchId}/investor-evaluation', ...options });
/**
 * List pitches
 *
 * List pitches for the current user. Founders see their startup pitches, investors see incoming pitches. Optional startupId query param returns published pitches for that startup.
 *
 * @deprecated
 */
export const listPitches = (options) => (options?.client ?? client).get({ url: '/api/v1/pitches', ...options });
/**
 * Create pitch session
 *
 * Create a new pitch session for a startup
 *
 * @deprecated
 */
export const createPitch = (options) => (options.client ?? client).post({
    url: '/api/v1/pitches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get pitch session
 *
 * Get a specific pitch session by ID. Accessible by the startup owner or linked investor.
 *
 * @deprecated
 */
export const getPitch = (options) => (options.client ?? client).get({ url: '/api/v1/pitches/{pitchId}', ...options });
/**
 * Update pitch session
 *
 * Update pitch session details such as cover image and publish status.
 *
 * @deprecated
 */
export const updatePitch = (options) => (options.client ?? client).patch({
    url: '/api/v1/pitches/{pitchId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Start pitch session
 *
 * Start the pitch session by creating LiveKit room. Returns session with token and URL. Can only be called when session status is ACTIVE.
 *
 * @deprecated
 */
export const startPitch = (options) => (options.client ?? client).post({ url: '/api/v1/pitches/{pitchId}/start', ...options });
/**
 * Finish pitch session
 *
 * Finish the pitch session by marking as completed. Can only be called when session status is IN_PROGRESS.
 *
 * @deprecated
 */
export const finishPitch = (options) => (options.client ?? client).post({ url: '/api/v1/pitches/{pitchId}/finish', ...options });
/**
 * Get pitch video URL
 *
 * Get a presigned URL to download the pitch session recording. Accessible by the startup owner or linked investor.
 *
 * @deprecated
 */
export const getPitchVideoUrl = (options) => (options.client ?? client).post({ url: '/api/v1/pitches/{pitchId}/video-url', ...options });
/**
 * List all startups (admin)
 *
 * @deprecated
 */
export const adminListStartups = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/startups', ...options });
/**
 * Get startup by ID (admin)
 *
 * @deprecated
 */
export const adminGetStartupById = (options) => (options.client ?? client).get({ url: '/api/v1/admin/startups/{id}', ...options });
/**
 * List all users (admin)
 *
 * @deprecated
 */
export const adminListUsers = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/users', ...options });
/**
 * Delete user and associated data (admin)
 *
 * @deprecated
 */
export const adminDeleteUser = (options) => (options.client ?? client).delete({
    url: '/api/v1/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get user by ID (admin)
 *
 * @deprecated
 */
export const adminGetUserById = (options) => (options.client ?? client).get({ url: '/api/v1/admin/users/{id}', ...options });
/**
 * List all investors (admin)
 *
 * @deprecated
 */
export const adminListInvestors = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/investors', ...options });
/**
 * Get investor by ID (admin)
 *
 * @deprecated
 */
export const adminGetInvestorById = (options) => (options.client ?? client).get({ url: '/api/v1/admin/investors/{id}', ...options });
/**
 * Get investor persona with metric prompts (admin)
 *
 * @deprecated
 */
export const adminGetInvestorPersona = (options) => (options.client ?? client).get({ url: '/api/v1/admin/investors/{id}/persona', ...options });
/**
 * Trigger persona research for investor (admin)
 *
 * @deprecated
 */
export const adminTriggerPersonaResearch = (options) => (options.client ?? client).post({
    url: '/api/v1/admin/investors/{id}/persona/research',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List all evaluations (admin)
 *
 * @deprecated
 */
export const adminListEvaluations = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/evaluations', ...options });
/**
 * Delete a single evaluation (admin)
 */
export const adminDeleteEvaluation = (options) => (options.client ?? client).delete({ url: '/api/v1/admin/evaluations/{id}', ...options });
/**
 * Get evaluation by ID (admin)
 *
 * @deprecated
 */
export const adminGetEvaluationById = (options) => (options.client ?? client).get({ url: '/api/v1/admin/evaluations/{id}', ...options });
/**
 * Regenerate evaluation for a pitch session (admin)
 *
 * @deprecated
 */
export const adminRegenerateEvaluation = (options) => (options.client ?? client).post({
    url: '/api/v1/admin/evaluations/{id}/regenerate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List all feedback (admin)
 *
 * @deprecated
 */
export const adminListFeedback = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/feedback', ...options });
/**
 * List startup credit transactions (admin)
 *
 * @deprecated
 */
export const adminListStartupCredits = (options) => (options.client ?? client).get({ url: '/api/v1/admin/startups/{id}/credits', ...options });
/**
 * Add credits to startup (admin)
 *
 * @deprecated
 */
export const adminAddStartupCredits = (options) => (options.client ?? client).post({
    url: '/api/v1/admin/startups/{id}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List investor credit transactions (admin)
 *
 * @deprecated
 */
export const adminListInvestorCredits = (options) => (options.client ?? client).get({ url: '/api/v1/admin/investors/{id}/credits', ...options });
/**
 * Add credits to investor (admin)
 *
 * @deprecated
 */
export const adminAddInvestorCredits = (options) => (options.client ?? client).post({
    url: '/api/v1/admin/investors/{id}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List all prescreen requests (admin)
 *
 * @deprecated
 */
export const adminListPrescreens = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/prescreens', ...options });
/**
 * Trigger a new prescreen for a startup (admin)
 */
export const adminTriggerPrescreen = (options) => (options.client ?? client).post({
    url: '/api/v1/admin/prescreens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get startups with documents but no prescreen (admin)
 */
export const adminGetEligibleStartups = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/prescreens/eligible-startups', ...options });
/**
 * Delete a prescreen request and its evaluations (admin)
 */
export const adminDeletePrescreen = (options) => (options.client ?? client).delete({ url: '/api/v1/admin/prescreens/{id}', ...options });
/**
 * Get prescreen by ID (admin)
 *
 * @deprecated
 */
export const adminGetPrescreenById = (options) => (options.client ?? client).get({ url: '/api/v1/admin/prescreens/{id}', ...options });
/**
 * Get documents for a prescreen startup (admin)
 */
export const adminGetPrescreenDocuments = (options) => (options.client ?? client).get({ url: '/api/v1/admin/prescreens/{id}/documents', ...options });
/**
 * Rerun prescreen with a selected document (admin)
 */
export const adminRerunPrescreen = (options) => (options.client ?? client).post({
    url: '/api/v1/admin/prescreens/{id}/rerun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a pitch session and all its evaluations (admin)
 */
export const adminDeletePitchSession = (options) => (options.client ?? client).delete({ url: '/api/v1/admin/pitch-sessions/{id}', ...options });
/**
 * Get documents for a startup (admin)
 */
export const adminGetStartupDocuments = (options) => (options.client ?? client).get({ url: '/api/v1/admin/startups/{startupId}/documents', ...options });
/**
 * List all onboarding chat conversations (admin)
 *
 * @deprecated
 */
export const adminListOnboarding = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/onboarding', ...options });
/**
 * Get onboarding conversation by ID (admin)
 *
 * @deprecated
 */
export const adminGetOnboardingById = (options) => (options.client ?? client).get({ url: '/api/v1/admin/onboarding/{id}', ...options });
/**
 * List all data rooms (admin)
 *
 * @deprecated
 */
export const adminListDataRooms = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/data-rooms', ...options });
/**
 * Get data room by ID with content (admin)
 *
 * @deprecated
 */
export const adminGetDataRoomById = (options) => (options.client ?? client).get({ url: '/api/v1/admin/data-rooms/{id}', ...options });
/**
 * Get data room analytics (admin)
 *
 * @deprecated
 */
export const adminGetDataRoomAnalytics = (options) => (options.client ?? client).get({ url: '/api/v1/admin/data-rooms/{id}/analytics', ...options });
/**
 * Get user deletion preview (admin)
 *
 * @deprecated
 */
export const adminGetUserDeletionPreview = (options) => (options.client ?? client).get({ url: '/api/v1/admin/users/{id}/deletion-preview', ...options });
/**
 * List all automated emails (admin)
 *
 * @deprecated
 */
export const adminListAutomatedEmails = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/automated-emails', ...options });
/**
 * Get automated email by ID (admin)
 *
 * @deprecated
 */
export const adminGetAutomatedEmailById = (options) => (options.client ?? client).get({ url: '/api/v1/admin/automated-emails/{id}', ...options });
/**
 * Scrape LinkedIn profile data via Apify
 */
export const processLinkedIn = (options) => (options.client ?? client).post({
    url: '/api/v1/process/linkedin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Extract startup data from a pitch deck PDF
 */
export const processPitchDeck = (options) => (options.client ?? client).post({
    url: '/api/v1/process/pitch-deck',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Extract data from a website using AI
 */
export const processWebsite = (options) => (options.client ?? client).post({
    url: '/api/v1/process/website',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create a new startup
 */
export const v2CreateStartup = (options) => (options.client ?? client).post({
    url: '/api/v2/startups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get startup overview dashboard
 */
export const v2GetStartupOverview = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/overview', ...options });
/**
 * Get startup profile for data room
 */
export const v2GetStartupProfile = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/profile', ...options });
/**
 * Update startup profile
 */
export const v2UpdateStartupProfile = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{startupId}/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get pitch overview for startup
 */
export const v2GetStartupPitch = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/pitch', ...options });
/**
 * Get startup credit balance
 */
export const v2GetStartupCreditBalance = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/credits/balance', ...options });
/**
 * List startup credit transactions
 */
export const v2ListStartupCredits = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/credits', ...options });
/**
 * Get startup settings
 */
export const v2GetStartupSettings = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/settings', ...options });
/**
 * Get analytics settings (exclusions)
 */
export const v2GetAnalyticsSettings = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/settings/analytics', ...options });
/**
 * Add an email or domain to the analytics exclusion list
 */
export const v2CreateAnalyticsExclusion = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/settings/analytics/exclusions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove an analytics exclusion entry
 */
export const v2DeleteAnalyticsExclusion = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/settings/analytics/exclusions/{exclusionId}', ...options });
/**
 * Get startup activity feed
 */
export const v2GetStartupFeed = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/feed', ...options });
/**
 * Get full pitch evaluation detail
 */
export const v2GetPitchEvaluation = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/evaluation/{evaluationId}', ...options });
/**
 * Get judge profile for a specific evaluation
 */
export const v2GetJudgeProfile = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/evaluation/{evaluationId}/judge/{judgeKey}', ...options });
/**
 * Trigger prescreen for a pitch deck document
 */
export const v2TriggerPrescreen = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/prescreen/{documentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get startup activity log
 */
export const v2GetStartupActivity = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/activity', ...options });
/**
 * List team members
 */
export const v2ListTeamMembers = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/members', ...options });
/**
 * Create a team member
 */
export const v2CreateTeamMember = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Reorder team members
 */
export const v2ReorderTeamMembers = (options) => (options.client ?? client).put({
    url: '/api/v2/startups/{startupId}/members/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a team member
 */
export const v2DeleteTeamMember = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/members/{memberId}', ...options });
/**
 * Update a team member
 */
export const v2UpdateTeamMember = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{startupId}/members/{memberId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Force re-scrape of a team member's LinkedIn profile
 */
export const v2RefreshTeamMemberLinkedIn = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/members/{memberId}/refresh-linkedin', ...options });
/**
 * Remove a startup member (owner only, cannot remove owners)
 */
export const v2RemoveStartupMember = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/startup-members/{memberId}', ...options });
/**
 * List recommended investors for a startup
 */
export const v2ListStartupMatches = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/matches', ...options });
/**
 * Request a custom-persona evaluation against the latest pitch
 *
 * Resolves the most recent COMPLETED pitch session for the startup and creates an investor evaluation request against it. Idempotent.
 */
export const v2RequestStartupMatchEvaluation = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/matches/{investorId}/evaluate', ...options });
/**
 * Record that the founder clicked through to an investor website
 *
 * Fire-and-forget: logs a Recombee CartAddition signal. Does not send any outbound communication.
 */
export const v2RecordStartupContactInvestor = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/matches/{investorId}/contact', ...options });
/**
 * Create a new investor entity
 */
export const v2CreateInvestor = (options) => (options.client ?? client).post({
    url: '/api/v2/investors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor profile
 */
export const v2GetInvestorProfile = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/profile', ...options });
/**
 * Update investor profile
 */
export const v2UpdateInvestorProfile = (options) => (options.client ?? client).patch({
    url: '/api/v2/investors/{investorId}/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor persona status and brief
 */
export const v2GetInvestorPersona = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/persona', ...options });
/**
 * Get investor credit balance
 */
export const v2GetInvestorCreditBalance = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/credits/balance', ...options });
/**
 * List investor credit transactions
 */
export const v2ListInvestorCredits = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/credits', ...options });
/**
 * Get investor pitch feed
 */
export const v2GetInvestorFeed = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/feed', ...options });
/**
 * Get evaluation detail for investor
 */
export const v2GetInvestorEvaluation = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/evaluation/{evaluationId}', ...options });
/**
 * Get judge profile for investor evaluation
 */
export const v2GetInvestorJudgeProfile = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/evaluation/{evaluationId}/judge/{judgeKey}', ...options });
/**
 * Send connection request to startup from evaluation
 */
export const v2InvestorConnectWithStartup = (options) => (options.client ?? client).post({
    url: '/api/v2/investors/{investorId}/evaluation/{evaluationId}/connect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List all evaluation requests for investor
 */
export const v2ListInvestorEvaluationRequests = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/evaluation-requests', ...options });
/**
 * Request personalized evaluation
 *
 * Request a personalized evaluation using the investor custom persona.
 */
export const v2RequestInvestorEvaluation = (options) => (options.client ?? client).post({ url: '/api/v2/investors/{investorId}/pitches/{pitchSessionId}/investor-evaluation', ...options });
/**
 * Evaluate startup from investor perspective
 *
 * Triggers a custom evaluation for a startup. Uses the latest completed pitch session if available, otherwise falls back to prescreen using the pitch deck.
 */
export const v2EvaluateStartup = (options) => (options.client ?? client).post({ url: '/api/v2/investors/{investorId}/startups/{startupId}/evaluate', ...options });
/**
 * Get current user's profile data
 */
export const v2GetMe = (options) => (options?.client ?? client).get({ url: '/api/v2/user/me', ...options });
/**
 * Update current user's profile data
 *
 * Update user information including name, bio, location, and social links
 */
export const v2UpdateMe = (options) => (options?.client ?? client).patch({
    url: '/api/v2/user/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * Get all memberships (startups and investors) the current user belongs to
 */
export const v2GetMyMemberships = (options) => (options?.client ?? client).get({ url: '/api/v2/user/me/memberships', ...options });
/**
 * List pending invites for a startup
 */
export const v2ListStartupInvites = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/invites', ...options });
/**
 * Invite a user to a startup
 */
export const v2CreateStartupInvite = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Cancel a pending invite
 */
export const v2CancelStartupInvite = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/invites/{inviteId}', ...options });
/**
 * List pending invites for an investor
 */
export const v2ListInvestorInvites = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/invites', ...options });
/**
 * Invite a user to an investor organization
 */
export const v2CreateInvestorInvite = (options) => (options.client ?? client).post({
    url: '/api/v2/investors/{investorId}/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Cancel a pending investor invite
 */
export const v2CancelInvestorInvite = (options) => (options.client ?? client).delete({ url: '/api/v2/investors/{investorId}/invites/{inviteId}', ...options });
/**
 * Look up invite details by token
 */
export const v2LookupInvite = (options) => (options.client ?? client).get({ url: '/api/v2/invites/{token}', ...options });
/**
 * Accept a team invite
 */
export const v2AcceptInvite = (options) => (options.client ?? client).post({
    url: '/api/v2/invites/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create pitch session
 */
export const v2CreatePitch = (options) => (options.client ?? client).post({
    url: '/api/v2/pitches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get pitch session
 */
export const v2GetPitch = (options) => (options.client ?? client).get({ url: '/api/v2/pitches/{pitchId}', ...options });
/**
 * Update pitch session
 */
export const v2UpdatePitch = (options) => (options.client ?? client).patch({
    url: '/api/v2/pitches/{pitchId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Start pitch session
 */
export const v2StartPitch = (options) => (options.client ?? client).post({ url: '/api/v2/pitches/{pitchId}/start', ...options });
/**
 * Finish pitch session
 */
export const v2FinishPitch = (options) => (options.client ?? client).post({ url: '/api/v2/pitches/{pitchId}/finish', ...options });
/**
 * Get pitch video URL
 */
export const v2GetPitchVideoUrl = (options) => (options.client ?? client).post({ url: '/api/v2/pitches/{pitchId}/video-url', ...options });
/**
 * List share links for a startup
 */
export const v2ListShareLinks = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/share-links', ...options });
/**
 * Create a new share link
 */
export const v2CreateShareLink = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/share-links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a share link
 */
export const v2DeleteShareLink = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/share-links/{linkId}', ...options });
/**
 * Update a share link
 */
export const v2UpdateShareLink = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{startupId}/share-links/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get public profile preview by share link token
 */
export const v2GetPublicProfilePreview = (options) => (options.client ?? client).get({ url: '/api/v2/public/profile/{token}', ...options });
/**
 * Register as a profile visitor with email
 */
export const v2RegisterProfileVisitor = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get full public startup profile by share link token
 */
export const v2GetPublicProfileFull = (options) => (options.client ?? client).get({ url: '/api/v2/public/profile/{token}/full', ...options });
/**
 * Send a heartbeat for profile viewing analytics
 */
export const v2ProfileHeartbeat = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Track a profile interaction event (click, document open/close)
 */
export const v2ProfileTrackEvent = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Track multiple profile events in a single request (for page unload)
 */
export const v2ProfileTrackEventBatch = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get a presigned download URL for a public profile document
 */
export const v2PublicDocumentDownload = (options) => (options.client ?? client).post({ url: '/api/v2/public/profile/{token}/documents/{documentId}/download', ...options });
/**
 * Get a presigned URL for the pitch recording video
 */
export const v2PublicVideoUrl = (options) => (options.client ?? client).post({ url: '/api/v2/public/profile/{token}/video-url', ...options });
/**
 * Send a connection request message to the startup founder
 */
export const v2ContactFounder = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Submit or remove a thumbs up/down reaction on a statement
 */
export const v2SubmitStatementReaction = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/reaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get all statement reactions for a visitor
 */
export const v2GetStatementReactions = (options) => (options.client ?? client).get({ url: '/api/v2/public/profile/{token}/reactions', ...options });
/**
 * Submit agree/disagree feedback on selected text
 */
export const v2SubmitTextFeedback = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/text-feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get anonymized founder analytics for a startup
 */
export const v2GetStartupAnalytics = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/analytics', ...options });
/**
 * Get the latest AI engagement report
 */
export const v2GetInsightsReport = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/analytics/insights', ...options });
/**
 * Generate AI-powered engagement report from investor behavior
 */
export const v2GenerateAnalyticsInsights = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/analytics/insights', ...options });
/**
 * Get public investor profile by slug
 */
export const v2GetPublicInvestorBySlug = (options) => (options.client ?? client).get({ url: '/api/v2/public/investors/{slug}', ...options });
/**
 * Get website stats
 *
 * Returns aggregate counts used on the marketing landing page
 */
export const v2GetWebsiteStats = (options) => (options?.client ?? client).get({ url: '/api/v2/public/stats', ...options });
/**
 * Submit user feedback (general or evaluation)
 */
export const v2CreateFeedback = (options) => (options.client ?? client).post({
    url: '/api/v2/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List all users (admin)
 */
export const v2AdminListUsers = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/users', ...options });
/**
 * Delete user and associated data (admin)
 */
export const v2AdminDeleteUser = (options) => (options.client ?? client).delete({
    url: '/api/v2/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get user by ID (admin)
 */
export const v2AdminGetUserById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/users/{id}', ...options });
/**
 * Get user memberships (startups and investors)
 */
export const v2AdminGetUserMemberships = (options) => (options.client ?? client).get({ url: '/api/v2/admin/users/{id}/memberships', ...options });
/**
 * Get user deletion preview (admin)
 */
export const v2AdminGetUserDeletionPreview = (options) => (options.client ?? client).get({ url: '/api/v2/admin/users/{id}/deletion-preview', ...options });
/**
 * List all startups (admin)
 */
export const v2AdminListStartups = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/startups', ...options });
/**
 * Get startup by ID (admin)
 */
export const v2AdminGetStartupById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}', ...options });
/**
 * List startup credit transactions (admin)
 */
export const v2AdminListStartupCredits = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/credits', ...options });
/**
 * Add credits to startup (admin)
 */
export const v2AdminAddStartupCredits = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/startups/{id}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get subscription status for a startup (admin)
 */
export const v2AdminGetStartupSubscription = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/subscription', ...options });
/**
 * Create or update subscription for a startup (admin)
 */
export const v2AdminUpsertStartupSubscription = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/startups/{id}/subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Record a one-off purchase for a startup (admin)
 */
export const v2AdminAddStartupPurchase = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/startups/{id}/subscription/purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get documents for a startup (admin)
 */
export const v2AdminGetStartupDocuments = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{startupId}/documents', ...options });
/**
 * Get startup memberships (admin)
 */
export const v2AdminGetStartupMemberships = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/memberships', ...options });
/**
 * Get startup team members (admin)
 */
export const v2AdminGetStartupTeamMembers = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/team-members', ...options });
/**
 * List recommended investors for a startup (admin)
 */
export const v2AdminListStartupMatches = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/matches', ...options });
/**
 * Get the latest matcher refresh request for a startup (admin)
 */
export const v2AdminGetStartupMatchesRefreshStatus = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/matches/refresh', ...options });
/**
 * Enqueue a matcher refresh for a startup (admin)
 *
 * Inserts a PENDING StartupMatchRefreshRequest. The engine scheduler picks it up and runs the matcher pipeline. Idempotent: if a request is already PENDING/PROCESSING, returns it.
 */
export const v2AdminRefreshStartupMatches = (options) => (options.client ?? client).post({ url: '/api/v2/admin/startups/{id}/matches/refresh', ...options });
/**
 * Schedule LinkedIn scrape for all team members missing raw data (admin)
 *
 * Finds team members with a LinkedIn URL but no rawLinkedInData (and not already SCRAPING) and triggers an async scrape for each. Returns immediately with the count of scheduled scrapes. Progress is visible via linkedinScrapeStatus on each member.
 */
export const v2AdminBackfillTeamMemberLinkedIn = (options) => (options?.client ?? client).post({ url: '/api/v2/admin/team-members/backfill-linkedin', ...options });
/**
 * List all investors (admin)
 */
export const v2AdminListInvestors = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investors', ...options });
/**
 * Get investor by ID (admin)
 */
export const v2AdminGetInvestorById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}', ...options });
/**
 * Get investor persona with metric prompts (admin)
 */
export const v2AdminGetInvestorPersona = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/persona', ...options });
/**
 * Trigger persona research for investor (admin)
 */
export const v2AdminTriggerPersonaResearch = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/investors/{id}/persona/research',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List investor credit transactions (admin)
 */
export const v2AdminListInvestorCredits = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/credits', ...options });
/**
 * Add credits to investor (admin)
 */
export const v2AdminAddInvestorCredits = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/investors/{id}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor memberships (admin)
 */
export const v2AdminGetInvestorMemberships = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/memberships', ...options });
/**
 * List all evaluations (pitch + prescreen) unified
 */
export const v2AdminListEvaluations = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/evaluations', ...options });
/**
 * Get evaluation in view format (same as founder detail)
 */
export const v2AdminGetEvaluationView = (options) => (options.client ?? client).get({ url: '/api/v2/admin/evaluations/{id}/view', ...options });
/**
 * Get single evaluation raw details with research data
 */
export const v2AdminGetEvaluationDetails = (options) => (options.client ?? client).get({ url: '/api/v2/admin/evaluations/{id}/details', ...options });
/**
 * Get judge profile for an evaluation (admin)
 */
export const v2AdminGetJudgeProfile = (options) => (options.client ?? client).get({ url: '/api/v2/admin/evaluations/{evaluationId}/judge/{judgeKey}', ...options });
/**
 * Regenerate evaluation for a pitch session (admin)
 */
export const v2AdminRegenerateEvaluation = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/evaluations/{id}/regenerate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Rerun prescreen with a selected document (admin)
 */
export const v2AdminRerunPrescreen = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/prescreens/{id}/rerun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a prescreen request and its evaluations (admin)
 */
export const v2AdminDeletePrescreen = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/prescreens/{id}', ...options });
/**
 * Delete a pitch session and all its evaluations (admin)
 */
export const v2AdminDeletePitchSession = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/pitch-sessions/{id}', ...options });
/**
 * Delete a single evaluation (admin)
 */
export const v2AdminDeleteEvaluation = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/evaluations/{id}', ...options });
/**
 * List all data rooms (admin)
 */
export const v2AdminListDataRooms = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/data-rooms', ...options });
/**
 * Get data room by ID with content (admin)
 */
export const v2AdminGetDataRoomById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/data-rooms/{id}', ...options });
/**
 * Get data room analytics (admin)
 */
export const v2AdminGetDataRoomAnalytics = (options) => (options.client ?? client).get({ url: '/api/v2/admin/data-rooms/{id}/analytics', ...options });
/**
 * List latest AI insight reports per startup (admin)
 */
export const v2AdminListAiInsightReports = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/ai-insights', ...options });
/**
 * Manually regenerate the AI insight report for a startup (admin)
 */
export const v2AdminRegenerateAiInsightReport = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/ai-insights/regenerate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List text highlight feedbacks for a startup
 */
export const v2AdminListStartupTextFeedbacks = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/text-feedbacks', ...options });
/**
 * List statement reactions (agree/disagree) for a startup
 */
export const v2AdminListStartupReactions = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/reactions', ...options });
/**
 * List all feedback (admin)
 */
export const v2AdminListFeedback = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/feedback', ...options });
/**
 * List all automated emails (admin)
 */
export const v2AdminListAutomatedEmails = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/automated-emails', ...options });
/**
 * Get automated email by ID (admin)
 */
export const v2AdminGetAutomatedEmailById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/automated-emails/{id}', ...options });
/**
 * List all blog posts (admin)
 */
export const v2AdminListBlogPosts = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/blog-posts', ...options });
/**
 * Create a new blog post
 */
export const v2AdminCreateBlogPost = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/blog-posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a blog post
 */
export const v2AdminDeleteBlogPost = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/blog-posts/{id}', ...options });
/**
 * Get blog post by ID (admin)
 */
export const v2AdminGetBlogPost = (options) => (options.client ?? client).get({ url: '/api/v2/admin/blog-posts/{id}', ...options });
/**
 * Update a blog post
 */
export const v2AdminUpdateBlogPost = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/blog-posts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List published blog posts
 */
export const v2ListPublishedBlogPosts = (options) => (options?.client ?? client).get({ url: '/api/v2/blog-posts', ...options });
/**
 * Get a published blog post by slug
 */
export const v2GetPublishedBlogPost = (options) => (options.client ?? client).get({ url: '/api/v2/blog-posts/{slug}', ...options });
/**
 * Get current subscription status and usage
 */
export const v2GetSubscriptionStatus = (options) => (options.client ?? client).get({ url: '/api/v2/subscriptions/status', ...options });
/**
 * Create Stripe Checkout session for subscription
 */
export const v2CreateSubscriptionCheckout = (options) => (options.client ?? client).post({
    url: '/api/v2/subscriptions/checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create Stripe Customer Portal session
 */
export const v2CreateSubscriptionPortal = (options) => (options.client ?? client).post({
    url: '/api/v2/subscriptions/portal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Purchase one-off session or evaluation
 */
export const v2PurchaseOneOff = (options) => (options.client ?? client).post({
    url: '/api/v2/subscriptions/purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Handle Stripe webhook events
 */
export const v2StripeWebhook = (options) => (options?.client ?? client).post({ url: '/api/v2/webhooks/stripe', ...options });
